import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=587322b0&scoped=true&"
import script from "./Partner.vue?vue&type=script&lang=js&"
export * from "./Partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587322b0",
  null
  
)

export default component.exports